import { Quote, Star } from "lucide-react";
import { useEffect, useRef, useState } from "react";

const Testimonials: React.FC = () => {
	const [isVisible, setIsVisible] = useState(false);
	const sectionRef = useRef<HTMLElement>(null);

	useEffect(() => {
		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry?.isIntersecting) setIsVisible(true);
			},
			{ threshold: 0.1 },
		);
		if (sectionRef.current) observer.observe(sectionRef.current);
		return () => observer.disconnect();
	}, []);

	const reviews = [
		{
			name: "Markus S.",
			car: "Porsche 911 GT3",
			text: "Absolute Perfektion. Mein Wagen sah nach der Keramikversiegelung besser aus als bei der Werksauslieferung. Die Liebe zum Detail ist hier spürbar.",
		},
		{
			name: "Andreas K.",
			car: "Audi RS6",
			text: "Die beste Adresse im Ruhrgebiet für High-End Aufbereitung. Professionell, ehrlich und ein Ergebnis, das sprachlos macht.",
		},
		{
			name: "Christian W.",
			car: "BMW M4 Competition",
			text: "Sympathisches Team und handwerkliche Höchstleistung. Wer sein Fahrzeug liebt, bringt es zu Wildförster. 100% Weiterempfehlung.",
		},
	];

	return (
		<section
			ref={sectionRef}
			className="bg-black py-32 px-6 relative overflow-hidden"
		>
			{/* Decorative Background Icon */}
			<Quote className="absolute -top-10 -right-10 w-64 h-64 text-white/[0.03] rotate-12 pointer-events-none" />

			<div className="max-w-7xl mx-auto relative z-10">
				<div className="text-center mb-24">
					<p className="text-[#cfc297] text-xs uppercase tracking-[0.8em] font-black mb-4">
						Voices of Excellence
					</p>
					<h2 className="text-5xl md:text-7xl font-black uppercase tracking-tighter text-white">
						Kunden<span className="text-[#cfc297]">stimmen</span>
					</h2>
				</div>

				<div className="grid grid-cols-1 md:grid-cols-3 gap-8">
					{reviews.map((review, idx) => (
						<div
							key={review.name}
							className={`bg-zinc-900/50 backdrop-blur-sm p-10 rounded-sm border border-white/5 transition-all duration-1000 delay-${idx * 200} ${
								isVisible
									? "opacity-100 translate-y-0"
									: "opacity-0 translate-y-10"
							}`}
						>
							<div className="flex gap-1 mb-6">
								{[...Array(5)].map((_, i) => (
									<Star
										key={i}
										className="w-3 h-3 fill-[#cfc297] text-[#cfc297]"
									/>
								))}
							</div>

							<p className="text-white/70 italic text-lg leading-relaxed mb-8 font-light">
								"{review.text}"
							</p>

							<div className="pt-6 border-t border-white/5">
								<p className="text-white font-black uppercase tracking-widest text-sm italic">
									{review.name}
								</p>
								<p className="text-[#cfc297] text-[10px] uppercase tracking-widest font-bold mt-1">
									{review.car}
								</p>
							</div>
						</div>
					))}
				</div>

				{/* Google Review Badge Simulation */}
				<div className="mt-20 flex flex-col items-center">
					<div className="px-6 py-3 bg-white/5 border border-white/10 rounded-full flex items-center gap-4 hover:bg-white/10 transition-colors cursor-pointer group">
						<img
							src="https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_92x30dp.png"
							alt="Google"
							className="h-4 grayscale brightness-200 group-hover:grayscale-0 transition-all"
						/>
						<div className="h-4 w-px bg-white/20" />
						<span className="text-white/40 text-[10px] uppercase font-black tracking-widest">
							5.0 Sterne bei Google Reviews
						</span>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Testimonials;
